import React from "react";
// Vee Rule Delete Modal

// Mui
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

// Custom
import ContainedButton from "../../forms/button/ContainedButton";

const VeeRuleDeleteModal = ({
  type,
  onDelete,
  onClose,
}: {
  type?: string | null;
  onDelete: () => void;
  onClose: () => void;
}) => {
  return (
    <Dialog
      onClose={onClose}
      open={type ? true : false}
      maxWidth={false}
      sx={{
        "& .MuiPaper-root": {
          width: "500px",
          maxWidth: "none",
        },
      }}
    >
      <Stack
        direction={"row"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <DialogTitle sx={{ m: 0, p: 2 }}>Delete Node</DialogTitle>
        <IconButton onClick={onClose} sx={{ marginRight: "10px" }}>
          <CloseIcon />
        </IconButton>
      </Stack>

      <DialogContent dividers>
        <Typography variant="h6" mt={"10px"} mb={"10px"}>
          Do you want to delete {type} node?
        </Typography>

        <DialogActions sx={{ padding: "20px 0 0 0" }}>
          <ContainedButton
            label={"Delete"}
            sx={{
              width: "fit-content",
              fontWeight: 600,
              color: "#ffffff",
            }}
            onClick={onDelete}
          />
          <ContainedButton
            label={"Close"}
            bgColor={"linear-gradient(180deg, #FF7F7F 0%, #FF4D4D 100%)"}
            sx={{
              fontWeight: 600,
              color: "#ffffff",
            }}
            onClick={onClose}
          />
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};

export default VeeRuleDeleteModal;
